import React from 'react'
import "../latest_blog/LatestBlog.css"
import ReusableLatestBlog from '../organic1-reusable/ReusableLatestBlog'
import { Container, Row } from 'react-bootstrap'
const LatestBlog = () => {
  return (
    <section id="latest_blog">
      <Container>
        <h1 class="text-center">Latest Blog</h1>
          <Row className='pt-5' style={{rowGap:'40px'}}>
            <ReusableLatestBlog img="imeges/desktop1/latest_blog background.png"/>
            <ReusableLatestBlog img="imeges/desktop1/latest_blog background 2.png"/>
            <ReusableLatestBlog img="imeges/desktop1/latest_blog background 1.png"/>
          </Row>
      </Container>
    </section>
  )
}

export default LatestBlog